import styled from 'styled-components'

export const Iframe = styled.iframe`
  border: none;
  height: 100%;
  overflow: hidden;
  transition: height 0.3s ease;
  width: 100%;
`

export const Root = styled.div`
  min-width: 430px;
  position: fixed;
  right: 8px;
  bottom: 10vh;
  z-index: 1000;
`
